import commonService from "./common-service";

class DSService {
  async getDiseaseStates() {
    try {
      const response = await commonService.getFromServer(
        "EOM/DiseaseStates",
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async createDrug(params) {
    try {
      let response = await commonService.postToServer(
        "EOM/DiseaseStates",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async uploadDocument(params) {
    try {
      const response = await commonService.postToServer(
        "EOM/DiseaseStates/Upload",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async downloadDocument(params) {
    try {
      await commonService.downloadFromServer("EOM/DiseaseStates/Download", {
        fileName: "AllDiseaseStates.xlsx",
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async updateDrug(params) {
    try {
      let response = await commonService.updateToServer(
        "EOM/DiseaseStates/" + params.id,
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getDrug(id) {
    try {
      const response = await commonService.getFromServer(
        "EOM/DiseaseStates/" + id,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.msg.error);
    }
  }

  async deleteDrug(id) {
    try {
      const response = await commonService.deleteToServer(
        "EOM/DiseaseStates/" + id,
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error deleting drug");
      }
    } catch (e) {
      throw new Error("Error deleting drug");
    }
  }

  async getScreens(month, year) {
    try {
      const response = await commonService.getFromServer(
        "ProcessStates/" + year + "/" + month,
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error getting data");
      }
    } catch (e) {
      throw new Error("Error getting data");
    }
  }

  async getGeneralDS() {
    try {
      const response = await commonService.getFromServer(
        "EOM/DiseaseStates/DiseaseStates",
        {}
      );
      if (response) {
        return response.sort();
      } else {
        throw new Error(
          "Error retrieving payors. Please contact administrator."
        );
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getSHPDS() {
    try {
      const response = await commonService.getFromServer(
        "EOM/DiseaseStates/ShpDiseaseStates",
        {}
      );
      if (response) {
        return response.sort();
      } else {
        throw new Error(
          "Error retrieving payors. Please contact administrator."
        );
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getDetailDS() {
    try {
      const response = await commonService.getFromServer(
        "EOM/DiseaseStates/DetailedDiseaseStates",
        {}
      );
      if (response) {
        return response.sort();
      } else {
        throw new Error(
          "Error retrieving payors. Please contact administrator."
        );
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
}

export default new DSService();
